// extracted by mini-css-extract-plugin
export default {"welcome-wrapper":"CreateClass_welcome-wrapper__vs3tf","description":"CreateClass_description__Izs4I","fadeIn":"CreateClass_fadeIn__tYxL2","fadeOut":"CreateClass_fadeOut__2tY5u"};